import { useQuery } from "react-query";
import { fetchAPIProduct, fetchAPIProductId } from "../requests/Products";

export function useQueryProduct(id: number) {
    const onError = () => {};
    const query = useQuery("apiProducts", async () => await fetchAPIProduct(id), { onError });
    return query;
}

export function useQueryProductId(id: number) {
    const onError = () => {};
    const query = useQuery(`apiProductId${id}`, () => fetchAPIProductId(id), { onError });
    return query;
}